import { useMemo } from "react";
import { Add, Minus, Star1 } from "iconsax-react";
import { useTranslation } from "react-i18next";
import { numberWithCommas } from "../../utils/methods";

export const FoodCard = ({ card, onSelectProduct, basketItems }) => {
    const { t } = useTranslation();
    const sale = card?.restaurant_sale_cards?.[0];
    const price = sale?.price;
    const coin = sale?.coin;
    const orderAmount = useMemo(() => {
        const group = (basketItems || []).find(
            (item) => item[0]?.id === card.id
        );
        return group ? group.length : 0;
    }, [basketItems, card.id]);
    const inBasket = orderAmount > 0;
    const rating =
        card?.computed_score != null && card.computed_score !== ""
            ? Number(card.computed_score)
            : null;

    const addProduct = () => {
        if (!price || inBasket) return;
        onSelectProduct((prev) => [...prev, [card]]);
    };

    const increaseOrderCount = () => {
        onSelectProduct((prev) =>
            prev.map((group) =>
                group[0]?.id === card.id ? [...group, card] : group
            )
        );
    };

    const decreaseOrderCount = () => {
        onSelectProduct((prev) =>
            prev
                .map((group) => {
                    if (group[0]?.id !== card.id) return group;
                    return group.slice(0, -1);
                })
                .filter((group) => group.length > 0)
        );
    };

    return (
        <article className={`sales-card${inBasket ? " is-in-basket" : ""}`}>
            <div className="sales-card__media">
                {card?.photo ? (
                    <img src={card.photo} alt="" />
                ) : (
                    <span aria-hidden="true">
                        {(card?.name || "?").slice(0, 1)}
                    </span>
                )}
                {rating > 0 ? (
                    <span className="sales-card__rating">
                        <Star1 size={12} variant="Bold" aria-hidden="true" />
                        {rating.toLocaleString(undefined, {
                            maximumFractionDigits: 1,
                        })}
                    </span>
                ) : null}
            </div>
            <div className="sales-card__body">
                <h3>{card?.name}</h3>
                {card?.description ? <p>{card.description}</p> : null}
                <div className="sales-card__meta">
                    {price ? (
                        <div className="sales-card__price">
                            <strong>{numberWithCommas(String(price))}</strong>
                            <small>{t("currency")}</small>
                        </div>
                    ) : null}
                    {coin ? (
                        <div className="sales-card__coin">
                            {coin} {t("sales.coin")}
                        </div>
                    ) : null}
                </div>
                {price ? (
                    inBasket ? (
                        <div className="sales-card__qty">
                            <button
                                type="button"
                                aria-label={t("sales.decrease")}
                                onClick={decreaseOrderCount}
                            >
                                <Minus size={16} />
                            </button>
                            <span>{orderAmount}</span>
                            <button
                                type="button"
                                aria-label={t("sales.increase")}
                                onClick={increaseOrderCount}
                            >
                                <Add size={16} />
                            </button>
                        </div>
                    ) : (
                        <button
                            type="button"
                            className="sales-card__add"
                            onClick={addProduct}
                        >
                            {t("add.to")}
                        </button>
                    )
                ) : null}
            </div>
        </article>
    );
};
